import styled from 'styled-components';

export const ServiceDisplayWrapper = styled.div``;
